import React, { useState, useEffect } from 'react';

const AddCategory = () => {
    const [categoryName, setCategoryName] = useState('');
    const [categories, setCategories] = useState([]);

    // Fetch categories from backend
    const fetchCategories = async () => {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/course/category`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
        });

        const data = await res.json();
        setCategories(data); // store in state
    };

    // Load categories when page loads
    useEffect(() => {
        fetchCategories();
    }, []);

    const handleAddCategory = async (event) => {
        event.preventDefault();

        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/course/category`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
            body: JSON.stringify({ name: categoryName }),
        });

        if (res.ok) {
            alert("Category Added Successfully");
            setCategoryName('');
            fetchCategories(); // <-- REFRESH LIST
        } else {
            alert("Failed to add category");
        }
    };

    return (
        <div className="container mt-5">
            <h2>Add New Category</h2>

            <form onSubmit={handleAddCategory}>
                <input
                    type="text"
                    value={categoryName}
                    onChange={(e) => setCategoryName(e.target.value)}
                />
                <button type="submit">Add Category</button>
            </form>

            <h3 className="mt-4">Categories:</h3>
            <div>
                {categories.map((category) => (
                    <p key={category.id}>{category.name}</p>
                ))}
            </div>
        </div>
    );
};

export default AddCategory;
